import { render, staticRenderFns } from "./CollectionsModuleMenu.vue?vue&type=template&id=18e94def"
import script from "./CollectionsModuleMenu.vue?vue&type=script&lang=js"
export * from "./CollectionsModuleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports